import React from "react";

export default function CustomSearchBar(props) {
  const {
    value = "",
    onChange = () => {},
    name = "",
    placeholder = "",
    onChangeKeyDown = () => {},
    className = "",
    inputStyle = {},
  } = props;
  return (
    <div className="custom-search-field">
      <input
        type="text"
        placeholder={placeholder}
        value={value || ""}
        onChange={onChange}
        name={name}
        onKeyDown={onChangeKeyDown}
        className={className}
        style={{ ...inputStyle }}
      />
    </div>
  );
}
